/**
 * A drill target within an insight: the primary segment that was clicked, plus
 * an optional secondary axis value when drilling into a matrix cell.
 */
export interface TopicSlice {
    primary: string;
    secondary?: string;
}

/**
 * Builds the L2 evidence route for a slice within a surface. Primary/secondary
 * travel as separate path segments, each independently percent-encoded, so any
 * value — including ones containing `~`, `/`, `&`, or spaces — round-trips through
 * the router.
 */
export function sliceToPath(basePath: string, topicId: string, slice: TopicSlice): string {
    const base = `${basePath}/${topicId}/${encodeURIComponent(slice.primary)}`;
    return slice.secondary === undefined ? base : `${base}/${encodeURIComponent(slice.secondary)}`;
}

/** Reconstructs a slice from the (already URL-decoded) route params. */
export function sliceFromParams(primaryKey: string | undefined, secondaryKey: string | undefined): TopicSlice | null {
    if (primaryKey === undefined || primaryKey.length === 0) return null;
    return secondaryKey !== undefined && secondaryKey.length > 0 ? { primary: primaryKey, secondary: secondaryKey } : { primary: primaryKey };
}
